import { createFileRoute, Link } from "@tanstack/react-router";
import { FileText, MessageCircle, ClipboardCheck, Award, Users, Sparkles } from "lucide-react";

export const Route = createFileRoute("/lexpractiq/how-it-works")({
  head: () => ({
    meta: [
      { title: "How SA LexPractiq works | Legal Experience Platform" },
      { name: "description", content: "10-step simulation engine: scenario, documents, drafting, AI mentor, rubric scoring, supervisor feedback, portfolio and certificate." },
      { property: "og:title", content: "How SA LexPractiq works" },
      { property: "og:description", content: "AI supervising attorney, real SA scenarios, verified portfolio." },
    ],
  }),
  component: HowItWorksPage,
});

const STEPS = [
  { icon: <Sparkles size={18} />, title: "Scenario introduction", body: "You're placed inside a realistic South African legal or compliance role with a brief and objectives." },
  { icon: <FileText size={18} />, title: "Document review", body: "Read the client file: transcripts, correspondence, evidence, contracts or policy extracts." },
  { icon: <ClipboardCheck size={18} />, title: "Task allocation", body: "Practical assignments — drafting, research, analysis — issued one at a time." },
  { icon: <MessageCircle size={18} />, title: "AI mentor guidance", body: "A supervising-attorney AI gives hints, asks Socratic questions, and reviews your reasoning — never the answers." },
  { icon: <ClipboardCheck size={18} />, title: "Submission", body: "Draft and submit through the integrated editor. Save at your own pace." },
  { icon: <Sparkles size={18} />, title: "AI assessment", body: "Rubric scoring across legal accuracy, IRAC reasoning, structure, communication and professionalism." },
  { icon: <Users size={18} />, title: "Supervisor feedback", body: "Narrative feedback in the voice of a supervising attorney — what worked, what to revise, what to read next." },
  { icon: <Award size={18} />, title: "Portfolio & certificate", body: "Verified certificate with QR code. High-quality submissions become portfolio pieces employers can view." },
];

function HowItWorksPage() {
  return (
    <div className="lxp-container" style={{ padding: "3rem 1.25rem", maxWidth: 900 }}>
      <span className="lxp-badge">How it works</span>
      <h1 style={{ fontSize: "clamp(1.8rem, 4vw, 2.6rem)", margin: "0.5rem 0 1rem", letterSpacing: "-0.02em" }}>
        A realistic workplace, powered by AI
      </h1>
      <p className="lxp-muted" style={{ fontSize: "1.05rem", lineHeight: 1.65, marginBottom: "2rem" }}>
        Every SA LexPractiq simulation follows the same 8-step workflow — modelled on how a candidate attorney is
        supervised in a real firm.
      </p>
      <div style={{ display: "grid", gap: "0.75rem" }}>
        {STEPS.map((s, i) => (
          <div key={s.title} className="lxp-card" style={{ display: "flex", gap: "1rem", alignItems: "start" }}>
            <span
              style={{
                minWidth: 42, height: 42, borderRadius: 10, background: "var(--lxp-accent-glow)",
                color: "var(--lxp-accent)", display: "grid", placeItems: "center", fontWeight: 700,
              }}
            >{String(i + 1).padStart(2, "0")}</span>
            <div>
              <h3 style={{ margin: "0 0 0.3rem", fontSize: "1.05rem", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                {s.icon} {s.title}
              </h3>
              <p className="lxp-muted" style={{ margin: 0, fontSize: "0.9rem", lineHeight: 1.6 }}>{s.body}</p>
            </div>
          </div>
        ))}
      </div>
      <div style={{ marginTop: "2.5rem", textAlign: "center" }}>
        <Link to="/lexpractiq/simulations" className="lxp-btn">Browse simulations</Link>
      </div>
    </div>
  );
}
